import React from 'react';
import styles from './ArticleCard.module.scss';

import Image from 'next/image';
import Container from 'components/container';
import { Heading, Body } from 'components/text';

import type { ArticleCardTypeProps } from '../types';

const ArticleCard: React.FC<ArticleCardTypeProps> = ({ article }) => {
  const { title, introduction, header_image, categories } = article;
  
  return (
    <Container className={styles.container}>
      <Container className={styles.imageContainer}>
        <Image
          priority
          src={header_image}
          layout="fill"
          objectPosition="center"
          objectFit="cover"
          alt={title}
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 100vw, 640px"
        />
      </Container>
      <div className={styles.cardHeader}>
        <div className={styles.categories}>
          {categories?.map((category, index) => (
            <Body key={index} color="gold-dark" weight="demiBold">
              {category.name}
            </Body>
          ))}
        </div>
        <Heading as="h4" color="grey-dark" weight="medium">
          {title}
        </Heading>
        <div className={styles.introduction}>
          <Body color="grey-dark" fontSize={18}>
            {introduction}
          </Body>
        </div>
      </div>
    </Container>
  );
};

export default ArticleCard;
